export default "__VITE_ASSET__52cfbe11__"